import { GenericApiResponse } from "@/interfaces/common.interface";
import client, { AppClient, AuthClient } from "@/utils/client";
import urlcat from "urlcat";

export const registerUser = (data: {}) => {
  return AppClient().post("/users/signUp", data);
};

export const getGeoData = <T>(
  type: string,
  {
    page = 1,
    limit = 10,
    query = "",
    addedBy,
    sort = {
      key: "name",
      order: "asc",
    },
  }: {
    page?: number;
    query?: string;
    limit?: number;
    addedBy?: string;
    sort?: {
      key: string;
      order: "asc" | "desc";
    };
  }
) => {
  const url = urlcat("/admin/:type", {
    type,
    page,
    query,
    addedBy,
    limit,
    sort,
  });

  return AuthClient().get<GenericApiResponse<T>>(url);
};
